import { AzBpmProcess } from '@azinformatica/loki'
import { mapGetters } from 'vuex'
import { actionTypes, fluxoProcesskey, getterTypes, mutationTypes } from '@/core/constants'

export default {
	data() {
		return {
			process: null,
			businessKey: null,
			processInstance: null,
			componentes: null,
			process_key: this.$store.getters[getterTypes.COMUM.GET_CAMUNDA_PROCESS_KEY](fluxoProcesskey.PEDIDO),
		}
	},
	computed: {
		...mapGetters({
			hasAuthority: getterTypes.PEDIDO.GET_HAS_AUTHORITY_FLUXO,
			atividadeNome: getterTypes.PEDIDO.GET_ETAPA_NOME,
			atividadeSituacao: getterTypes.PEDIDO.GET_ETAPA_SITUACAO,
			informacoesPedido: getterTypes.PEDIDO.GET_INFORMACOES,
			informacoesOcorrencia: getterTypes.OCORRENCIA.GET_INFORMACOES_OCORRENCIA,
		}),
	},
	methods: {
		async carregarInstancia(businessKey) {
			this.businessKey = businessKey
			await this.atualizaInstanciaDoProcesso()
		},
		async actionAfterBpm(task) {
			await this.exibirNotificacoes(task)
			await this.atualizaInstanciaDoProcesso(task)
		},

		async exibirNotificacoes(resultadoAcao) {
			if (resultadoAcao.error) {
				this.mostrarNotificacaoErroFluxo(resultadoAcao.error)
			} else {
				this.mostrarNotificacaoSucessoDefault()
			}
		},

		mostrarNotificacaoErroFluxo(erro) {
			this.mostrarNotificacaoErro(erro.response?.data?.message || 'Erro desconhecido')
		},

		async atualizaInstanciaDoProcesso(resultadoAcao) {
			this.process = new AzBpmProcess(this.$store, this.process_key, this.businessKey)
			await this.process.load()
			this.processInstance = this.process.getProcess().instance
			this.componentes = this.process.getComponents()
			this.setarHasAuthority(this.process.hasAuthority())
			this.setarInformacoesFluxoCabecalho(this.processInstance)
			await this.alterarTramitacaoOcorrencia(resultadoAcao)
		},
		setarHasAuthority(hasAuthority) {
			this.$store.commit(mutationTypes.PEDIDO.SET_HAS_AUTORITY, hasAuthority)
		},
		setarInformacoesFluxoCabecalho(processInstance) {
			this.$store.commit(mutationTypes.PEDIDO.SET_ETAPA_FLUXO, processInstance)
		},
		async alterarTramitacaoOcorrencia(resultadoAcao) {
			if (resultadoAcao && !resultadoAcao.error) {
				const payload = this.criarPayloadOcorrencia(resultadoAcao)
				await this.$store.dispatch(actionTypes.OCORRENCIA.ATUALIZAR_OCORRENCIA, payload)
			}
		},
		async receberAtividade() {
			const btnClaim = this.process.getButtonClaim()
			await btnClaim.action()
			await this.atualizaInstanciaDoProcesso()
		},

		criarPayloadOcorrencia(resultadoAcao) {
			return {
				idEntidade: this.informacoesOcorrencia.idEntidade,
				entidadeTipo: this.informacoesOcorrencia.tipoEntidade,
				acao: resultadoAcao.action,
			}
		},

		async setBpmProcess() {
			this.process = new AzBpmProcess(this.$store, this.process_key, this.businessKey)
			this.process.load()
		},
	},
}
